import { render, staticRenderFns } from "./Date.vue?vue&type=template&id=58ba1bdb&scoped=true&"
import script from "./Date.vue?vue&type=script&lang=js&"
export * from "./Date.vue?vue&type=script&lang=js&"
import style0 from "./Date.vue?vue&type=style&index=0&id=58ba1bdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ba1bdb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58ba1bdb')) {
      api.createRecord('58ba1bdb', component.options)
    } else {
      api.reload('58ba1bdb', component.options)
    }
    module.hot.accept("./Date.vue?vue&type=template&id=58ba1bdb&scoped=true&", function () {
      api.rerender('58ba1bdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/profile/components/ProfileField/field-types/Date.vue"
export default component.exports